import Skeleton from "@mui/material/Skeleton";

const TableLoader = () => {
  return (
    <>
      <Skeleton variant="text" width="100%" height={35} />
      <Skeleton variant="text" width="100%" height={35} />
      <Skeleton variant="text" width="100%" height={35} />
    </>
  );
};

export default TableLoader;
